/**
 * Dynamic SDS SDK loader — loads script only when Design mode activates
 */

import { store } from '../../core/store.js'
import { createLogger } from '../../utils/logger.js'

const log = createLogger('sdk-loader')
let loadPromise = null

export function loadSDK() {
  if (store.getState('design.isSDKLoaded')) {
    log.info('SDK already loaded')
    return Promise.resolve()
  }

  if (loadPromise) {
    log.info('SDK load already in progress')
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    log.info('Loading SDS SDK...')
    const script = document.createElement('script')
    script.src = '/lib/sds-sdk.js'
    script.onload = () => {
      log.info('SDS SDK loaded successfully')
      store.setState('design.isSDKLoaded', true)
      resolve()
    }
    script.onerror = (err) => {
      log.error('Failed to load SDS SDK:', err)
      loadPromise = null
      reject(new Error('SDS SDK failed to load'))
    }
    document.head.appendChild(script)
  })

  return loadPromise
}
